import { type IListItem, type TToastOptions } from "@monta/design-system";
import { ContentType } from "../educationPack";

export const toastOptionsError: TToastOptions = {
  message: "خطایی رخ داده",
  timeout: 4000,
  position: "bottom-right",
};

export const toastSuccessOptions: TToastOptions = {
  message: "عملیات با موفقیت انجام شد",
  timeout: 4000,
  position: "bottom-right",
};

export const errorToastOptionNoAccess: TToastOptions = {
  message: "شما به این محتوا دسترسی ندارید.",
  timeout: 4000,
  position: "bottom-right",
};
export const toastSuccessFeedbackOptions: TToastOptions = {
  message: "پیام شما با موفقیت ثبت شد",
  timeout: 4000,
  position: "bottom-right",
};

export const contentTypeFilter: IListItem[] = [
  { id: String(ContentType.PRACTICE), label: "تمرین" },
  { id: String(ContentType.LECTURE), label: "درسنامه" },
  { id: String(ContentType.EXAM), label: "آزمون" },
  { id: String(ContentType.VIDEO), label: "ویدیو" },
  { id: String(ContentType.PDF), label: "پی دی اف" },
  { id: String(ContentType.VOICE), label: "صوت" },
  { id: String(ContentType.DESCRIPTIVE_PRACTICE), label: "تکلیف تشریحی" },
];

export enum LevelsEnum {
  ELEMENTARY_SCHOOL = 20,
  MIDDLE_SCHOOL = 50,
  HIGHSCHOOL = 60,
}

export enum SchoolTypesEnum {
  NON_GOVERNMENTAL = 0,
  NON_PROFIT_SCHOOLS = 20,

  GOVERNMENT = 40,
  BOARD_OF_TRUSTEES = 50,
  BRILLIANT_TALENTS = 60,
  SHAHED = 70,
  TIZ_HOSHAN = 90,
  PEOPLE_PARTICIPATION = 100,
  REMOTE_NON_GOVERNMENTAL = 110,
  CONSERVATORIES = 130,
  EXCEPTIONAL = 140,
  ADULTS = 150,
  SEMI_GOVERNMENT = 160,
}
export const LabelSchoolTypeList = {
  [SchoolTypesEnum.NON_GOVERNMENTAL]: "غير دولتي",
  [SchoolTypesEnum.NON_PROFIT_SCHOOLS]: "غير دولتي",
  [SchoolTypesEnum.GOVERNMENT]: "دولتي",
  [SchoolTypesEnum.BOARD_OF_TRUSTEES]: "هيئت امنايي",
  [SchoolTypesEnum.BRILLIANT_TALENTS]: "استعداد هاي درخشان",
  [SchoolTypesEnum.SHAHED]: "شاهد",
  [SchoolTypesEnum.TIZ_HOSHAN]: "استعداد هاي درخشان",
  [SchoolTypesEnum.PEOPLE_PARTICIPATION]: "مشارکت مردم",
  [SchoolTypesEnum.REMOTE_NON_GOVERNMENTAL]: "راه دور-غير دولتي",
  [SchoolTypesEnum.CONSERVATORIES]: "هنرستان",
  [SchoolTypesEnum.EXCEPTIONAL]: "استثنايي",
  [SchoolTypesEnum.ADULTS]: "بزرگسالان",
  [SchoolTypesEnum.SEMI_GOVERNMENT]: "نيمه دولتي",
};
export const SchoolTypeList: Array<{
  value: string;
  label: string;
}> = [
  {
    value: SchoolTypesEnum.NON_GOVERNMENTAL.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.NON_GOVERNMENTAL],
  },

  {
    value: SchoolTypesEnum.GOVERNMENT.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.GOVERNMENT],
  },
  {
    value: SchoolTypesEnum.BOARD_OF_TRUSTEES.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.BOARD_OF_TRUSTEES],
  },
  {
    value: SchoolTypesEnum.BRILLIANT_TALENTS.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.BRILLIANT_TALENTS],
  },
  {
    value: SchoolTypesEnum.SHAHED.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.SHAHED],
  },
  {
    value: SchoolTypesEnum.PEOPLE_PARTICIPATION.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.PEOPLE_PARTICIPATION],
  },
  {
    value: SchoolTypesEnum.REMOTE_NON_GOVERNMENTAL.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.REMOTE_NON_GOVERNMENTAL],
  },
  {
    value: SchoolTypesEnum.CONSERVATORIES.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.CONSERVATORIES],
  },
  {
    value: SchoolTypesEnum.EXCEPTIONAL.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.EXCEPTIONAL],
  },
  {
    value: SchoolTypesEnum.ADULTS.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.ADULTS],
  },
  {
    value: SchoolTypesEnum.SEMI_GOVERNMENT.toString(),
    label: LabelSchoolTypeList[SchoolTypesEnum.SEMI_GOVERNMENT],
  },
];
export enum DemoTypesEnum {
  QUESTION_BANK = "QUESTION_BANK",
  EXAM_MAKER = "EXAM_MAKER",
}

export enum OtpTypesEnum {
  SIGN_UP = "SIGN_UP",
  LOGIN = "LOGIN",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  SUBMIT_PHONE_NUMBER = "SUBMIT_PHONE_NUMBER",
}
export const Levels = [
  { value: "60", label: "دوم متوسطه" },
  { value: "50", label: "اول متوسطه" },
  { value: "20", label: "دبستان" },
];

export const GradeMajors = [
  { value: "12_60", label: "دوازدهم ریاضی" },
  { value: "12_61", label: "دوازدهم تجربی" },
  { value: "12_62", label: "دوازدهم انسانی" },
  { value: "11_60", label: "یازدهم ریاضی" },
  { value: "11_61", label: "یازدهم تجربی" },
  { value: "11_62", label: "یازدهم انسانی" },
  { value: "10_60", label: "دهم ریاضی" },
  { value: "10_61", label: "دهم تجربی" },
  { value: "10_62", label: "دهم انسانی" },
  { value: "9_56", label: "نهم" },
  { value: "8_56", label: "هشتم" },
  { value: "7_56", label: "هفتم" },
  { value: "6_53", label: "ششم" },
  { value: "5_53", label: "پنجم" },
  { value: "3_53", label: "چهارم" },
];

export const Grades = [
  { value: 10, label: "دهم" },
  { value: 11, label: "یازدهم" },
  { value: 12, label: "دوازدهم" },
];

export const UserTypes = [
  {
    label: "دانش آموز",
    value: "1",
  },
  {
    label: "مشاور",
    value: "2",
  },
  {
    label: "مدرسه",
    value: "4",
  },
  {
    label: "دبیر",
    value: "9",
  },
  {
    label: "مرکز مشاوره",
    value: "21",
  },
  {
    label: "آموزشگاه",
    value: "20",
  },
];

export const SchoolTypes = [
  { value: "0", label: " غير دولتي" },
  { value: "10", label: " آموزشگاه" },
  { value: "20", label: " مدرسه غير انتفاعي" },
  { value: "30", label: " نمونه دولتي" },
  { value: "40", label: " دولتي" },
  { value: "50", label: " هيئت امنايي" },
  { value: "60", label: " استعداد هاي درخشان" },
  { value: "70", label: " شاهد" },
  { value: "80", label: " وابسته" },
  { value: "90", label: " تيز هوشان" },
  { value: "100", label: " مشارکت مردم" },
  { value: "110", label: " راه دور-غير دولتي" },
  { value: "120", label: " ايثارگران" },
  { value: "130", label: " هنرستان" },
  { value: "140", label: " استثنايي" },
  { value: "150", label: " بزرگسالان" },
  { value: "160", label: " نيمه دولتي" },
  { value: "200", label: " مشاور" },
  { value: "210", label: " معلم" },
  { value: "220", label: " مرکز مشاوره" },
];

export const GradeMajorsKeys = {
  ["12_60"]: "دوازدهم ریاضی",
  ["12_61"]: "دوازدهم تجربی",
  ["12_62"]: "دوازدهم انسانی",
  ["11_60"]: "یازدهم ریاضی",
  ["11_61"]: "یازدهم تجربی",
  ["11_62"]: "یازدهم انسانی",
  ["10_60"]: "دهم ریاضی",
  ["10_61"]: "دهم تجربی",
  ["10_62"]: "دهم انسانی",
  ["9_56"]: "نهم",
  ["8_56"]: "هشتم",
  ["7_56"]: "هفتم",
  ["6_53"]: "ششم",
  ["5_53"]: "پنجم",
  ["3_53"]: "چهارم",
  ["2_52"]: "سوم",
  ["1_52"]: "دوم",
  ["0_52"]: "اول",
};
